// extracted by mini-css-extract-plugin
export default {"each-circle":"circle_each-circle__vyHCH"};